<script setup lang="ts">
import { useFileDownload } from '@/composables/useFileDownload';
import type { MessageSchema } from '@/i18n';
import { usePlanningStore } from '@/stores/planningStore';
import Button from 'primevue/button';
import { useI18n } from 'vue-i18n';

const { t } = useI18n<{ message: MessageSchema }>({ useScope: 'global' });

const props = defineProps({
  image: {
    type: String,
    required: true,
  },
});
const downloadImage = async (imageUrl: string, filename: string) => {
  const { downloadFile } = useFileDownload();
  try {
    // Convert image URL to blob
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    await downloadFile({
      fileName: filename,
      data: blob,
      mimeType: 'image/png',
      showShareDialog: true,
    });
  } catch (error) {
    console.error('Error downloading image:', error);
    // Fallback to browser download for web
    const link = document.createElement('a');
    link.href = imageUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

const generateFileName = (plannedMenu) => {
  if (!plannedMenu) return 'menu.png';
  // fix plannedMenu name so there's no special character
  const name = plannedMenu.name.replace(/[^a-zA-Z0-9]/g, '_');
  // fix plannedMenu date so there's no special character
  const date = plannedMenu.date.replace(/[^a-zA-Z0-9]/g, '_');
  return `${name}-${date}.png`;
};

const shareMenu = async () => {
  const filename = generateFileName(usePlanningStore()?.selectedPlannedMenu);
  try {
    // Check if the Web Share API is available
    if (navigator.share) {
      // create a blob from the image URL
      const response = await fetch(props.image);
      const blob = await response.blob();

      // Utilise l'API Web Share pour ouvrir la modal de partage
      await navigator.share({
        title: 'Menu',
        text: 'Voici le menu à partager',
        files: [new File([blob], 'menu.png', { type: blob.type })], // Ajoute le fichier image
      });
    } else {
      // Si l'API Web Share n'est pas disponible, télécharge l'image
      await downloadImage(props.image, filename);
    }
  } catch (error) {
    console.error('Erreur lors du partage ou du téléchargement :', error);
  }
};
</script>

<template>
  <main>
    <!-- <div>
      <h1 class="text-2xl mb-4 text-center">{{ t('socialNetworks.share') }}</h1>
    </div> -->
    <img :src="image" alt="Share Image" class="mx-auto max-h-[70vh] w-full max-w-[600px] rounded-t-md object-contain shadow-md" />
    <div class="rounded-md shadow-md"></div>
    <div class="mt-8 w-full">
      <Button type="button" :label="t('socialNetworks.share')" icon="pi pi-share-alt" class="col-span-1 w-full" @click="shareMenu" />
      <!-- <Button class="col-span-1 w-full" @click="shareMenu()">
        <ButtonWithIconWrapper>
          <template #icon>
            <ButtonShare />
          </template>
          <template #label>
            {{ t('socialNetworks.share') }}
          </template>
        </ButtonWithIconWrapper>
      </Button> -->
    </div>
  </main>
</template>
